export default {"src":"/_next/static/media/money_sack.d5beec9a.svg","height":270,"width":269,"blurWidth":0,"blurHeight":0};